exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RadioCircle-module__wrapper___1Xj_k{display:flex;gap:.6em}.RadioCircle-module__wrapper___1Xj_k .RadioCircle-module__radio___2mteQ{width:22px;height:22px;border-radius:999px;display:flex;justify-content:center;align-items:center;cursor:pointer}.RadioCircle-module__wrapper___1Xj_k svg{transition:.25s}", ""]);

// exports
exports.locals = {
	"wrapper": "RadioCircle-module__wrapper___1Xj_k",
	"radio": "RadioCircle-module__radio___2mteQ"
};